import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { auditService } from '../../../shared/api/services/audit.service'

export const useAuditLogs = () => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [action, setAction] = useState<string>('')
    const [userId, setUserId] = useState<string>('')
    const [dateRange, setDateRange] = useState<[string, string] | null>(null)

    const { data, isLoading, isFetching, refetch } = useQuery({
        queryKey: ['auditLogs', page, pageSize, action, userId, dateRange],
        queryFn: () => auditService.getAll({
            page,
            per_page: pageSize,
            action: action || undefined,
            user_id: userId || undefined,
            start_date: dateRange?.[0] || undefined,
            end_date: dateRange?.[1] || undefined,
        }),
    })

    return {
        logs: data?.data || [],
        totalLogs: data?.meta?.total || 0,
        page,
        setPage,
        pageSize,
        setPageSize,
        action,
        setAction,
        userId,
        setUserId,
        dateRange,
        setDateRange,
        isLoading,
        isFetching,
        refetch
    }
}
